(function($)
{

    $.fn.dependentformfield = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.dependentformfield.defaults, options);

        return this.each(function() {
             var $this = $(this);
             // build element specific options
             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

            var $target = $(eOpts['target-selector']);
            
            var activeValue = eOpts['active-value'];
            var activeSelector = eOpts['active-selector'];
            var hideRow = eOpts['hide-row'];

            if (activeValue) {
                // init
                updateFieldWithValue($this, $target, activeValue, hideRow);
                $target.on('select',function () {
                    updateFieldWithValue($this, $target, activeValue, hideRow);
                });
            } else {
                // init
                updateFieldWithSelector($this, $target, activeSelector, hideRow);
                $target.change(function () {
                    updateFieldWithSelector($this, $target, activeSelector, hideRow);
                });
            }
         });
    };
    //
    // plugin defaults
    //
    $.fn.dependentformfield.defaults = {
        'target-selector': '',
        'active-value': '',
        'active-selector': '',
        'hide-row': false
    };

    function updateFieldWithValue($this, $target, activeValue, hideRow) {
        if($target.val() == activeValue) {
            enableField($this, hideRow);
        }
        else {
            disableField($this, hideRow);
        }
    }

    function updateFieldWithSelector($this, $target, activeSelector, hideRow) {
        if($target.is(activeSelector)) {
            enableField($this, hideRow);
        }
        else {
            disableField($this, hideRow);
        }
    }

    function enableField($this, hideRow) {
        if($this.is('.jqx-widget.dropdownlist')) {
            $this.jqxDropDownList({ disabled: false });
        }
        else if($this.is('.msx-duration-picker')) {
            $this.parent().find('.msx-duration-picker').prop('disabled', false);
        }
        else {
            $this.prop('disabled', false);
        }
        $this.trigger('enabled');
        $('label[for=' + $this.attr('id') + ']').removeClass('disabled');
        if(hideRow) {
            $this.closest('.form-row').show();
        }
    }

    function disableField($this, hideRow) {
        if($this.is('.jqx-widget.dropdownlist')) {
            $this.jqxDropDownList({ disabled: true });
        }
        else if($this.is('.msx-duration-picker')) {
            $this.parent().find('.msx-duration-picker').prop('disabled', true);
        }
        else {
            $this.prop('disabled', true);
            // uncheck if checked
            if($this.is(':checked')) {
                $this.prop('checked', false);
                $this.trigger('checked');
            }
        }
        $this.trigger('disabled');
        $('label[for=' + $this.attr('id') + ']').addClass('disabled');
        if(hideRow) {
            $this.closest('.form-row').hide();
        }
    }

})(jQuery);